import { GetWhoamiResponse } from "@shared/apiSchemas";
import { cmaBackendApi } from "../api";

const whoamiApi = cmaBackendApi.injectEndpoints({
  endpoints: (build) => ({
    /**
     * Get details of the current user
     */
    whoami: build.query<GetWhoamiResponse, void>({
      query: () => ({
        url: `/whoami`,
        method: "GET",
        params: {},
        needsAuth: true,
      }),
    }),
  }),
});

export const {
  useLazyWhoamiQuery,
  useWhoamiQuery,
  endpoints: whoamiEndpoints,
} = whoamiApi;
